import './styles.scss';
import { Handle, Position } from '@xyflow/react';
import { IconShoppingCartCheck } from '@tabler/icons-react';
import { Text } from '@fragments';

export default function EntryNode() {
    return (
        <div className="split-entry-node">
            <div className="sen-card">
                <span className="sen-icon">
                    <IconShoppingCartCheck size={20} />
                </span>
                <Text.h5 weight={400}>Venda confirmada</Text.h5>
            </div>

            <Handle
                type="source"
                position={Position.Right}
                className="split-flow-handle"
            />
        </div>
    );
}
